import { render } from "./CustomerLayout.vue?vue&type=template&id=76362886&scoped=true"
import script from "./CustomerLayout.vue?vue&type=script&lang=js"
export * from "./CustomerLayout.vue?vue&type=script&lang=js"

import "./CustomerLayout.vue?vue&type=style&index=0&id=76362886&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76362886"]])

export default __exports__